import { makeStyles } from '@mui/styles';
import { Route, Switch } from 'react-router';

import Navbar from '../../app/navbar/Navbar';
import HomeContainer from '../../modules/opDashboard/home/Home';
import { Locations as LocationsContainer } from '../../modules/opDashboard/locations/Locations';
import routes from '../../routes/routes.constants';
import { colors } from '../../utils/theme';

import ErroDialog from './common/dialog/error/ErrorDialog';
import LocationDetailsContainer from './locationDetails/LocationDetails';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    background: colors.PURE_WHITE,
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  navbarContainer: {
    width: '12em',
    height: '100%',
    minWidth: '12em',
    background: colors.OFF_WHITE,
    position: 'fixed',
    left: 0,
  },
  componentContainer: {
    width: 'calc(100% - 14em)',
    background: colors.PURE_WHITE,
    marginLeft: '14em',
    marginRight: '2em',
    minWidth: '72em',
    height: '100%',
  },
}));

const OpDashboard = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.navbarContainer}>
        <Navbar />
      </div>
      <ErroDialog />
      <div className={classes.componentContainer}>
        <Switch>
          <Route
            exact
            component={LocationsContainer}
            path={routes.VIDEA_INSIGHT_LOCATIONS}
          />
          <Route
            component={LocationDetailsContainer}
            path={routes.VIDEA_INSIGHT_LOCATION_DETAILS}
          />
          <Route
            component={HomeContainer}
            path={routes.VIDEA_INSIGHT_DASHBOARD}
          />
        </Switch>
      </div>
    </div>
  );
};

export default OpDashboard;
